// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"7":"c7454996","104":"c230894c","814":"1d479442","819":"3b6a3e67","999":"16590349"}[chunkId] + ".chunk.js";
};